// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"ab413ffd","243":"1deaa97a","277":"c985a130","380":"459f3a12","477":"9530cb57","530":"13ece599","986":"31c6e159"}[chunkId] + ".chunk.js";
};